import { CellphoneArrowDownVariantIcon } from './CellphoneArrowDownVariantIcon';

/**
 * author: Michael Irigoyen
 * id AF03DF0A-3E57-412D-B72E-67938C4FD599
 * name cellphone-arrow-down-variant
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cellphone-arrow-down-variant.svg
 * tags
 * - Cellphone / Phone 
 */
export const CellphoneDownloadIcon = CellphoneArrowDownVariantIcon;
export default CellphoneDownloadIcon